import { Head, useForm } from "@inertiajs/react"
import type { FormEvent } from "react"

import InputError from "@/components/input-error"
import TextLink from "@/components/text-link"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Spinner } from "@/components/ui/spinner"
import AppLayout from "@/layouts/app-layout"
import { invitationPath, newInvitationPath } from "@/routes"
import type { BreadcrumbItem } from "@/types"

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Send invitation",
    href: newInvitationPath(),
  },
]

export default function NewInvitation() {
  const { data, setData, post, processing, errors, reset } = useForm({
    name: "",
    email: "",
  })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    post(invitationPath(), { onSuccess: () => reset() })
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Send invitation" />

      <div className="max-w-md space-y-6 p-6">
        <form onSubmit={submit} className="space-y-6">
          <div className="grid gap-2">
            <Label htmlFor="name">Name</Label>
            <Input
              id="name"
              type="text"
              required
              autoFocus
              autoComplete="name"
              placeholder="Full name"
              value={data.name}
              onChange={(e) => setData("name", e.target.value)}
            />
            <InputError messages={errors.name} />
          </div>

          <div className="grid gap-2">
            <Label htmlFor="email">Email address</Label>
            <Input
              id="email"
              type="email"
              required
              autoComplete="off"
              placeholder="email@example.com"
              value={data.email}
              onChange={(e) => setData("email", e.target.value)}
            />
            <InputError messages={errors.email} />
          </div>

          <Button type="submit" className="w-full" disabled={processing}>
            {processing && <Spinner />}
            Send invitation
          </Button>
        </form>

        <div className="text-muted-foreground text-center text-sm">
          <TextLink href="/">Back to home</TextLink>
        </div>
      </div>
    </AppLayout>
  )
}
